// var api_url = exports.api_url = 'http://localhost:4000/api/'

// var cur_mode = 'PROD'
// var mode = exports.mode = 'PROD'

// var api_url = exports.api_url = (mode == cur_mode) ? 'https://kikone-api.herokuapp.com/api/' : 'http://localhost:4000/api/'

exports.mode = process.env.REACT_APP_MODE
exports.api_url = process.env.REACT_APP_API_URL


// WEBPACK FOOTER //
// ./src/config/config.js